import React, {
    useMemo, useEffect, useContext,
} from 'react';
import { DraftEditorStateContext } from '../../context/DraftEditorStateContext';
import TettraEditor from '../../tettra-editor/components/TettraEditor';

const CONFIG = {
    editorIdentifier: 'DraftEdit',
    spellCheck: true,
    readOnly: false,
};

const setUploading = (isUploading) => {
    window._tettraDraft.isUploading = isUploading;
};

export default ({ editorState: initialEditorState }) => {
    const { setDraftEditorState } = useContext(DraftEditorStateContext);

    const updateModel = (editorState) => {
        window._tettraDraft.editorState = editorState;
        return setDraftEditorState(editorState);
    };

    useEffect(() => updateModel(initialEditorState), [initialEditorState]);

    return useMemo(() => (
        <div id="post-editor-content" className="post-editor-content">
            <TettraEditor
                config={CONFIG}
                editorState={initialEditorState}
                updateModel={updateModel}
                setUploading={setUploading}
            />
        </div>
    ), [initialEditorState]);
};
